export const GET_SWAP_INFO_START = 'SWAPS/GET_SWAP_INFO_START';
export const GET_SWAP_INFO_SUCCESS = 'SWAPS/GET_SWAP_INFO_SUCCESS';
export const GET_SWAP_INFO_ERROR = 'SWAPS/GET_SWAP_INFO_ERROR';

export const GET_SWAP_STREAM_START = 'SWAP/GET_SWAP_STREAM_START';
export const GET_SWAP_STREAM_SUCCESS = 'SWAP/GET_SWAP_STREAM_SUCCESS';
export const UPDATE_SWAP_STREAM = 'SWAP/UPDATE_SWAP_STREAM';
export const GET_SWAP_STREAM_ERROR = 'SWAP/GET_SWAP_STREAM_ERROR';
export const SET_INTERVAL_ID = 'SWAP/SET_INTERVAL_ID';
